const authentication = {
  title: () => 'italist | Sign in and say hello to smart shopping'
};

export default authentication;
